"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMobileData = void 0;
var react_1 = __importStar(require("react"));
var date_fns_1 = require("date-fns");
var next_intl_1 = require("next-intl");
var apps_shared_1 = require("@l2p/apps-shared");
var ui_components_1 = require("@l2p/ui-components");
var useGetStatus_1 = require("./useGetStatus");
var useMobileData = function (filteredData) {
    var t = (0, next_intl_1.useTranslations)('translation');
    var getStatus = (0, useGetStatus_1.useGetStatus)();
    return (0, react_1.useMemo)(function () {
        return filteredData.map(function (item, idx) {
            var type = item.type, bonus = item.bonus, startAmount = item.startAmount, startBalance = item.startBalance, createdAt = item.createdAt, status = item.status, currency = item.currency, expireDate = item.expireDate, balance = item.balance, startWageringBalance = item.startWageringBalance, wageringBalance = item.wageringBalance;
            return {
                title: (bonus === null || bonus === void 0 ? void 0 : bonus.title) || '',
                added: (0, date_fns_1.format)(new Date(createdAt), 'HH:mm, dd-LL-yy'),
                content: type === apps_shared_1.BonusTypes.BONUSES
                    ? "".concat((0, apps_shared_1.getCurrencySymbol)(currency), " ").concat(Number(startBalance).toFixed(2))
                    : "".concat(startAmount, " ").concat(t('freespins')),
                status: (react_1.default.createElement(ui_components_1.StatusText, { textAlign: "flex-start", status: getStatus(status) }, t(status))),
                idx: idx,
                type: type,
                currency: currency,
                startBalance: startBalance,
                expireDate: expireDate,
                balance: balance,
                startWageringBalance: startWageringBalance,
                wageringBalance: wageringBalance,
                amount: startAmount,
            };
        });
    }, [getStatus, t, filteredData]);
};
exports.useMobileData = useMobileData;
